// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.account.AccountTransferPayload
import org.mifospay.core.model.savingsaccount.TransactionsEntity
import org.mifospay.core.model.savingsaccount.TransferDetail
import org.mifospay.core.model.search.AccountResult
import org.mifospay.core.network.model.entity.templates.account.AccountOptionsTemplate

@OptIn(InternalKtorfitApi::class)
public class _AccountTransfersServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : AccountTransfersService {
  override fun getTransaction(clientId: Long, transactionId: Long): Flow<TransactionsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$clientId".encodeURLPath()}/transactions/${"$transactionId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<TransactionsEntity>>(),)!! 
  }

  override fun getAccountTransfer(transferId: Int): Flow<TransferDetail> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "accounttransfers/${"$transferId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<TransferDetail>>(),)!! 
  }

  override fun searchAccounts(query: String, resource: String): Flow<List<AccountResult>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "search")
        query?.let{ parameter("query", "$it") }
        resource?.let{ parameter("resource", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<AccountResult>>>(),)!! 
  }

  override suspend fun makeTransfer(payload: AccountTransferPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "accounttransfers")
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override fun getAccountTransferTemplate(): Flow<AccountOptionsTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "accounttransfers/template")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<AccountOptionsTemplate>>(),)!! 
  }
}

public class _AccountTransfersServiceProvider : ClassProvider<AccountTransfersService> {
  override fun create(_ktorfit: Ktorfit): AccountTransfersService = _AccountTransfersServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createAccountTransfersService(): AccountTransfersService = _AccountTransfersServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
